import React from "react";

export const MainHeading = ({ heading }) => {
  return (
    <div className="d-flex justify-content-center">
      <h3 className="text-center font-600 my-2">{heading}</h3>
    </div>
  );
};
